import { EnvelopeIcon } from '@heroicons/react/24/outline'
import { useForm } from 'libs/form'
import { useTranslation } from 'libs/i18n'
import { BackButton, Form, FormSection, Header } from 'shared/components'
import { InputGroup } from 'shared/molecules'
import { routes } from 'config/routes'
import { PASSWORD_MIN_LENGTH, useAddUserValidationSchema } from './hooks/useAddUserValidationSchema'
import { useCreateUserMutation } from './mutations/useCreateUserMutation'

const UserAddPage = () => {
	const { t } = useTranslation()
	const validationResolver = useAddUserValidationSchema()

	const {
		handleSubmit,
		register,
		setError,
		formState: { errors }
	} = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})
	const fieldErrors = errors as any

	const { createUser, isCreateUserLoading } = useCreateUserMutation(setError)

	const onSubmit = (data: any) => {
		createUser(data)
	}

	return (
		<>
			<Header
				title={t('Add user')}
				actions={<BackButton to={routes.userIndex} text={t('Back to users')} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					submitText={t('Create user')}
					onSubmit={handleSubmit(onSubmit)}
					isLoading={isCreateUserLoading}>
					<FormSection
						title={t('Account')}
						description={t('Login email and password for this user.')}
						icon={<EnvelopeIcon />}>
						<InputGroup
							id="email"
							type="email"
							className="sm:col-span-2"
							label={t('Email')}
							placeholder="name@example.com"
							autoComplete="off"
							required
							{...register('email')}
							error={fieldErrors.email}
						/>
						<InputGroup
							id="password"
							type="password"
							label={t('Password')}
							placeholder={t('Minimum {{ count }} characters', { count: PASSWORD_MIN_LENGTH })}
							autoComplete="new-password"
							required
							{...register('password')}
							error={fieldErrors.password}
						/>
						<InputGroup
							id="password2"
							type="password"
							label={t('Confirm password')}
							placeholder={t('Repeat the password')}
							autoComplete="new-password"
							required
							{...register('password2')}
							error={fieldErrors.password2}
						/>
					</FormSection>
				</Form>
			</div>
		</>
	)
}

export default UserAddPage
